import React from 'react';

const InviteTeam = () => {
    return <div>InviteTeam</div>;
};

export default InviteTeam;
